export enum PlanType {
  FREE = "free",
  PRO = "pro",
}

export type FeatureKey = 'content' | 'menu' | 'branches' | 'faq' | 'multimedia' | 'loyalty' | 'survey';

export interface FeatureSettings {
  isEnabled?: boolean;
  limit?: number;
  storage?: number;
  features?: string[];
  message: string;
}

export type FeatureStatus = "enabled" | "disabled" | "info";

export interface Feature {
  label: string;
  value?: string | number;
  status?: FeatureStatus;
}

export interface FeatureGroup {
  title: string;
  features: Feature[];
}

export interface PricingPlan {
  id: string;
  title: string;
  price: number;
  priceSuffix: string;
  description: string;
  icon: string;
  accentColor: string;
  buttonVariant: "outlined" | "contained";
  isActive: boolean;
  recommended?: boolean;
  featureGroups: FeatureGroup[];
}